module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAV1JREFUWEftl0ESwyAIReVkbU/W5mRNTkbFqqMWRBIzk0XdRr9P0A8BRES3bzwAYKWliHh3zr33yEAECEKGQRtyAGadDAAAjxEAH7CXP/RTAFgAgL6rAxEpYvcKIIpTSoBTIPERAB9VAkzjRyvqsAC0UDrBSlEaBAjiQhheALD0IlDSlxqzAEKa/gD/CPQicJMesfEVSDKbeAlV9/ja7jlG5J1tGwGIc0QnNGhQpLMTGtblqdOKkeRYKlRTDdX5rL3vWjVxEVt0JuqrUlQNT0tBSlFJ0e6XyrFKykxQL6Gvej8RLp5xkCw7ohnPsOI0AUzqiI4BxE5GvBMDVtxmquoR4/pKv23JjnZEvbsUGpp2whQAadem5R8CSIWG0xRbsssCcGDxnuXGl2vLzU2pxUSuAFClmYuAeCDlx6T3fHPIRSc8w4jSSUpH7FmxJZXSzymrMQJg2TzNVYvRSAQ+5JVDln1q/AkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/codeNew.png
// module id = X0xF
// module chunks = 71